import React from "react";

import OrganisationalView from "@components/OrganisationalView/OrganisationalView";
import OrganisationCardDetail from "@components/OrganisationCardDetail/OrganisationCardDetail";
import { OrganisationCardProps } from "@models/components/organisation.model";

const OrganisationCard: React.FC<OrganisationCardProps> = ({ data }) => {
  return (
    <div className="fg-card-wrap" data-testid="organisation-card-test">
      <OrganisationCardDetail
        address={data.address}
        name={data?.title}
        mobileLogo={data?.mobileLogo}
        clubId={data.clubId}
      />
      <OrganisationalView
        occupation={data.occupation}
        totalResources={data.totalResources}
        clubId={data.clubId}
      />
    </div>
  );
};

export default OrganisationCard;
